import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark';

interface UIState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggleTheme: () => void;

  selectedFund: string;
  setSelectedFund: (f: string) => void;

  selectedDate: string | null;          // ISO yyyy-MM-dd
  setSelectedDate: (d: string | null) => void;

  sidebarCollapsed: boolean;
  toggleSidebar: () => void;

  editMode: boolean;
  setEditMode: (v: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      setTheme: (t) => set({ theme: t }),
      toggleTheme: () => set({ theme: get().theme === 'light' ? 'dark' : 'light' }),

      selectedFund: 'ARP Public',
      setSelectedFund: (f) => set({ selectedFund: f, selectedDate: null }),

      selectedDate: null,
      setSelectedDate: (d) => set({ selectedDate: d }),

      sidebarCollapsed: false,
      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),

      editMode: false,
      setEditMode: (v) => set({ editMode: v }),
    }),
    {
      name: 'arp-ui-state',
      partialize: (s) => ({
        theme: s.theme,
        selectedFund: s.selectedFund,
        sidebarCollapsed: s.sidebarCollapsed,
      }),
    },
  ),
);
